<div fxFlex="initial" fxLayout="column" class="row-filter row-container grid-filter-container" fxLayoutGap="5px">
  <div fxFlex="initial" fxFlexFill fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutGap="5px" >
    <mat-form-field class="full-width no-hint" appearance="outline" *ngIf="!hideSearchInput">
      <mat-icon matPrefix>search</mat-icon>
      <input #inputTrigger matInput type="text"
             [placeholder]="placeholder"
             [formControl]="searchControl"
             [matAutocomplete]="autoComplete">
      <mat-autocomplete #autoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="optionSelected($event)">
        <mat-option *ngFor="let item of filteredOptions | async" [value]="item">
          <b>{{ item.title }}:</b> {{ item.displayValue }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
      <app-mat-date-range *ngIf="showDateRange" (onDateRangeSelected)="onDateRangeSelected($event)"></app-mat-date-range>
      <ng-content select="app-filter-row-additional-content"></ng-content>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
    <button mat-stroked-button *ngIf="showFilterButton" class="only-icon" (click)="onFilterButtonClicked.emit($event)">
      <mat-icon>filter_list</mat-icon>
    </button>
    <mat-chip-listbox>
      <mat-chip-option class="filter-chip" color="primary" [removable]="!readonly" highlighted [selectable]="false"
                *ngFor="let item of selectedItems" (removed)="removeFilter(item)">
        <div>
          {{ item.title }}:
          <span class="filter-values">
              <span>{{item.displayValues.join(', ')}}</span>
            </span>
        </div>
        <mat-icon *ngIf="!readonly" matChipRemove>close</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>
    <ng-content select="app-filter-second-row-additional-content"></ng-content>
  </div>
</div>
